<template>
  <div>
    <p class="text-2xl mb-6">Création par Mots-clés automatisés (Marfeel)</p>

    <v-card class="mb-6 pa-2" outlined>
      <v-row class="ma-3">
        <v-col cols="12">
          <filters/>
        </v-col>
      </v-row>
    </v-card>

    <v-expansion-panels v-model="page.openPanel" class="mb-2">
      <v-expansion-panel :key="0">
        <v-expansion-panel-header>
          <p class="text-xl" v-if="page.openPanel !== 0">Fréquences</p>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-col cols="12" class="d-flex flex-row-reverse">
            <v-btn color="primary" @click="page.dialog.frequency = true">
              <v-icon class="mr-3">{{ icons.mdiPlusBox }}</v-icon
              >Nouvelle Fréquence</v-btn
            >
          </v-col>

          <FrequencyTable ref="frequencyTable" process-type="keyword" />
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    

    <v-col cols="12" class="d-flex flex-row-reverse">
      <v-btn color="primary" @click="page.dialog.config = true">
        <v-icon class="mr-3">{{ icons.mdiPlusBox }}</v-icon
        >Nouvelle Configuration</v-btn
      >
    </v-col>

    <KeywordConfigTable ref="configTable" />

    <v-dialog v-model="page.dialog.config">
      <KeywordConfigCreation
        @close-dialog="page.dialog.config = false"
        @saved="handleConfigSaved"
      />
    </v-dialog>
    <v-dialog v-model="page.dialog.frequency">
      <FrequencyCreation
        @close-dialog="page.dialog.frequency = false"
        @saved="handleFrequencySaved"
        process-type="keyword"
      />
    </v-dialog>
    <v-snackbar
      v-model="page.successMessage.show"
      color="success"
      timeout="3000"
      top
    >
      {{ page.successMessage.text }}
    </v-snackbar>
  </div>
</template>

<script>
import { reactive, onMounted } from "@vue/composition-api";
import { mdiPlusBox } from "@mdi/js";

import KeywordConfigCreation from "@/components/ai-factory/full-auto/cards/KeywordConfigCreation.vue";
import FrequencyCreation from "@/components/ai-factory/full-auto/cards/FrequencyCreation.vue";
import Filters from "@/components/ai-factory/full-auto/filters/Filters.vue";
import KeywordConfigTable from "@/components/ai-factory/full-auto/tables/KeywordConfigTable.vue";
import FrequencyTable from "@/components/ai-factory/full-auto/tables/FrequencyTable.vue";

import useProxy from "@/hooks/useProxy";

import { saveRmraView } from "@/utils/rmr-analytics";

export default {
  name: "AutomatedKeywordProcess",
  components: {
    KeywordConfigTable,
    KeywordConfigCreation,
    Filters,
    FrequencyCreation,
    FrequencyTable,
  },
  setup(props, { emit }) {
    const { refs, route } = useProxy();

    const page = reactive({
      dialog: {
        config: false,
        frequency: false,
      },
      openPanel: undefined,
      successMessage: {
        show: false,
        text: '',
      },
    });

    // =>  METHODS
    const handleConfigSaved = async () => {
      page.successMessage.text = 'Config créée avec succès';
      page.successMessage.show = true;
      refs.configTable.refresh();
    };

    const handleFrequencySaved = async () => {
      page.successMessage.text = 'Fréquence créée avec succès';
      page.successMessage.show = true;
      refs.frequencyTable.refresh();
    };

    // =>  COMPUTED

    // =>  WATCH

    // =>  HOOKS
    onMounted(async () => {
      saveRmraView(route);
    });

    // =>  DATA
    return {
      handleConfigSaved,
      handleFrequencySaved,
      icons: {
        mdiPlusBox,
      },
      page,
    };
  },
};
</script>

<style></style>
